import React from 'react';
import { Icon } from '@iconify/react';

interface SectionHeaderProps {
  title: string;
  icon?: string;
  actions?: React.ReactNode;
}

const SectionHeader: React.FC<SectionHeaderProps> = ({ title, icon, actions }) => {
  return (
    <div style={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      marginBottom: 'var(--space-md)',
    }}>
      <h3 style={{
        fontFamily: 'var(--font-heading)',
        fontSize: '18px',
        fontWeight: 600,
        color: 'var(--text-primary)',
        display: 'flex',
        alignItems: 'center',
        gap: '10px',
        margin: 0,
      }}>
        {icon && <Icon icon={icon} width={20} style={{ color: 'var(--primary-600)' }} />}
        {title}
      </h3>
      {actions && <div style={{ display: 'flex', gap: '8px' }}>{actions}</div>}
    </div>
  );
};

export default SectionHeader;
